import React, { useEffect, useState } from "react";
import { SafeAreaView, ActivityIndicator } from "react-native";
import { CommonActions, useRoute } from '@react-navigation/native';
import { Container } from "./style";
import Header from "../../components/Header";
import THEME from "../../config/theme";
import SearchBar from "../../components/SearchBar";
import { useCustomTheme } from '../../contexts/useCustomTheme';
import { useAuthUser } from '../../contexts/useAuthUser';

export function ClickSearch({ navigation }) {
  const { params } = useRoute();
  const productCatalogOrigin = params?.productCatalogOrigin;
  const allowedCardKeys = params?.allowedCardKeys;
  const [visible, setVisible] = useState(false);
  // Sessão e documento `users/{uid}` já resolvidos no boot.
  const { user, isLoadingUser: isLoading } = useAuthUser();

  const { customColor } = useCustomTheme();

  const handleGoBack = () => {
    if (productCatalogOrigin) {
      navigation.navigate('CatalogoProdutos', {
        title: productCatalogOrigin.title,
        productId: productCatalogOrigin.productId,
      });
      return;
    }

    if (navigation.canGoBack()) {
      navigation.goBack();
      return;
    }

    navigation.dispatch(
      CommonActions.navigate(
        user?.isAdmin
          ? { name: 'Admin', params: { screen: 'Conteudo' } }
          : { name: 'Conteudo', params: { screen: 'Aplicativo' } }
      )
    );
  };

  useEffect(() => {
    const timer = setTimeout(() => setVisible(!visible), 2000);
    return () => clearTimeout(timer);
  }, []);

  return isLoading ? (
    <ActivityIndicator
      style={{
        flex: 1,
        backgroundColor:
          customColor && customColor.background
            ? customColor.background.auth
            : THEME.COLORS.BACKGROUND_ABOUT,
        justifyContent: 'center',
      }}
      color={
        customColor && customColor.primary
          ? customColor.primary
          : THEME.COLORS.PRIMARY_800
      }
    />
  ) : (
    <SafeAreaView
      style={{
        flex: 1,
        backgroundColor:
          customColor && customColor.background
            ? customColor.background.app
            : THEME.COLORS.BACKGROUND_MAIN,
      }}
    >
      <Header
        style={{
          backgroundColor:
            customColor && customColor.background
              ? customColor.background.app
              : THEME.COLORS.BACKGROUND_MAIN,
        }}
        onPress={handleGoBack}
        user={user}
      />
      <Container>
        <SearchBar
          visible={visible}
          user={user}
          allowedCardKeys={allowedCardKeys}
          productCatalogOrigin={productCatalogOrigin}
        />
      </Container>
    </SafeAreaView>
  );
}
